import { render, staticRenderFns } from "./ProposalImage.vue?vue&type=template&id=42352a8a&scoped=true"
import script from "./ProposalImage.vue?vue&type=script&lang=js"
export * from "./ProposalImage.vue?vue&type=script&lang=js"
import style0 from "./ProposalImage.vue?vue&type=style&index=0&id=42352a8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42352a8a",
  null
  
)

export default component.exports